import { object, string, number } from "yup"

export const createEditExclusionModel = object({
  policy_applicant_id: number().integer().positive().required("MISSING_REQUIRED_FIELD"),
  exclusion: string().required("MISSING_REQUIRED_FIELD")
})
